import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { AngularUpgradeHelper } from '../helpers/AngularUpgradeHelper';
import { CellularDeviceStatusComponent } from './cellular-device-status.component';
import { MatButtonModule } from '@angular/material/button';
import { FormsModule } from '@caslink/common-client/ng-app/forms/FormsModule';

@NgModule({
    declarations: [
        CellularDeviceStatusComponent
    ],
    entryComponents: [
        CellularDeviceStatusComponent
    ],
    exports: [
        CellularDeviceStatusComponent
    ],
    imports: [
        CommonModule,
        MatButtonModule,
        FormsModule
    ],
})
export class CellularDeviceStatusModule {
    private commonModuleName = 'app.areas.common';

    constructor() {
        AngularUpgradeHelper.downgradeComponents(this.commonModuleName, [
            CellularDeviceStatusComponent
        ]);
    }
}
